import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { auth } from '../../firebase';
import headerStyles from './Header.module.css';
import logo from '../../Icon-1024.png'

const Header = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            setIsLoggedIn(!!user);
        });
        return () => unsubscribe();
    }, []);

    const handleLogout = () => {
        auth.signOut();
    };

    return (
        <header className={headerStyles.header}>
            <div className={headerStyles.logo}>
                <Link to="/"><img src={logo} alt="Logo" className={headerStyles.logo}/></Link>
            </div>
            <div className={headerStyles.buttons}>
                {isLoggedIn ? (
                    <>
                        {location.pathname !== '/' && <Link to="/" className={headerStyles.greenButton}>Home</Link>}
                        {location.pathname !== '/dashboard' && <Link to="/dashboard" className={headerStyles.greenButton}>Dashboard</Link>}
                        <button onClick={handleLogout} className={headerStyles.greyButton}>Log Out</button>
                    </>
                ) : (
                    <>
                        {location.pathname !== '/login' && <Link to="/login" className={headerStyles.greenButton}>Sign In</Link>}
                        {location.pathname !== '/signup' && <Link to="/signup" className={headerStyles.filledButton}>Sign Up</Link>}
                    </>
                )}
            </div>
        </header>
    );
};

export default Header;